import type { PlotStage } from '../plot/PlotStage'
import { emptyPlot } from '../plot/overlays'

export type PlotFallback = {
  /** Shows a doc; blank docs show the empty plot instead of scaffolding. */
  readonly show: (doc: string) => void
  readonly destroy: () => void
}

const FAILED = new Set(['runtime-error', 'syntax-error', 'overheated', 'crashed'])

/**
 * A checkpoint that parses can still throw once it runs (a half-typed name,
 * say). Replays never show that: fall back to the last doc that drew a frame.
 */
export const createPlotFallback = (stage: PlotStage): PlotFallback => {
  let loadedDoc: string | null = null
  let lastGoodDoc: string | null = null

  const load = (doc: string): void => {
    loadedDoc = doc
    stage.runner.load(doc)
  }
  const unsubFrame = stage.runner.onFrame(() => {
    lastGoodDoc = loadedDoc
  })
  const unsubState = stage.runner.onState((state) => {
    if (FAILED.has(state) && lastGoodDoc !== null && loadedDoc !== lastGoodDoc) load(lastGoodDoc)
  })

  return {
    show: (doc) => {
      if (doc.trim() === '') {
        if (loadedDoc === null) stage.view.render(emptyPlot())
        return
      }
      if (doc !== loadedDoc) load(doc)
    },
    destroy: () => {
      unsubFrame()
      unsubState()
    },
  }
}
